<style scoped>
@font-face {
  font-family: 'iconfont';  /* project id 1805586 */
  src: url('//at.alicdn.com/t/font_1805586_kpnnhtv7v6s.eot');
  src: url('//at.alicdn.com/t/font_1805586_kpnnhtv7v6s.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_1805586_kpnnhtv7v6s.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_1805586_kpnnhtv7v6s.woff') format('woff'),
  url('//at.alicdn.com/t/font_1805586_kpnnhtv7v6s.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_1805586_kpnnhtv7v6s.svg#iconfont') format('svg');
}
.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  color: #fff;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
.active {
  font-weight: bold;
}
	.navBox{
    width:100%;
    height:60px;
    /* background: linear-gradient(136deg, #FF923E 0%, #FF6F00 100%); */
    background: #6376F7;
    position: relative;
    min-width:1440px;
  }
  .nav{
    width:1440px;
    margin:0 auto;
    height:auto;
    position: relative;
  }

  .navLeft{
    float:left;
    width:auto;
    height:60px;
    position: relative;
    cursor: pointer;
  }
  .logo{
    width:37px;
    height:37px;
    position: relative;
    top:12px;
    float:left;
  }
  .logo img{
    width:100%;
    height:100%;
  }
  .navLeft .title{
    width:auto;
    position: relative;
    height:37px;
    line-height: 37px;
    font-size:25px;
    font-family:PingFang SC;
    font-weight:bold;
    color:#fff;
    /* float:left; */
    top:12px;
    /* display: flex; */
    margin-left:10px;
    margin-right: 10px;
  }
  .navLeft .title .roleVersion p{
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
    padding-left: 10px;
  }
  .navText{
    height:22px;
    width:auto;
    float:left;
    position: relative;
    top:27px;
    line-height: 22px;
    color:#fff;
    font-family:PingFang SC;
    font-weight:400;
    font-size:16px;
	/* margin-left:15px; */
  }
  .navText:not(:last-child) {
    /* margin-right: 30px; */
  }
  .navRight{
    float:right;
    height:60px;
    width:auto;
    position: relative;
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
  }
  .backEndNavList{
    width:auto;
    position: relative;
    float:right;
    height: 60px;
    /* margin-right:60px; */
  }
  .backEndNavList .more{
    position: relative;
  }
  .backEndNavList .more ul{
    position: absolute;
    left: -20px;
    top: 60px;
    background-color: #fff;
    z-index: 2;
    width: 128px;
    padding: 10px 0;
    box-shadow:0px 3px 6px rgba(0,0,0,0.16);
    border-radius:6px;
  }
  .navList .more ul li{
    list-style: none;
    height: 50px;
    line-height: 50px;
    color: #333;
  }
  .backEndNavList .more ul li:hover{
    background-color: #EBEAF8;
  }
  .backEndNavList .navListItem{
    height:60px;
    width:auto;
    padding:0 18px;
    margin:0 10px;
    float:left;
    line-height: 60px;
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:#fff;
    position: relative;
    cursor: pointer;
  }
  .navListItem div{
    height:4px;
    width:100%;
    border-radius: 2px;
    background: #fff;
    position: absolute;
    left:0;
    bottom: 6px;
  }
  .mobile_navList {
  	display: none;
  }
  .navBoxOther {
  	display: none;
  }
  .backPersonCenter{
    float: right;
    display: flex;
    align-items: center;
    height: 60px;
    color: #fff;
    cursor: pointer;
    margin-left: 50px;
    position: relative;
  }
  .backPersonCenter .moreFunBox{
    width: 140px;
    /* height: 120px; */
    /* border: 1px solid #F8F8F8; */
    box-shadow: 1px 3px 6px rgba(0, 0, 0, 0.16);
    background-color: #fff;
    border-radius: 10px;
    position: absolute;
    top: 56px;
    z-index: 101;
  }
  .backPersonCenter .moreFunBox >div{
    height: 40px;
    line-height: 40px;
    color: #4D4D4D;
  }
  .backPersonCenter .moreFunBox >div:last-child{
    border-radius: 0 0 10px 10px;
  }
  .backPersonCenter .moreFunBox >div:first-child{
    border-radius: 10px 10px 0 0;
  }
  .backPersonCenter .moreFunBox >div:hover{
    background-color: rgba(189, 198, 255, 0.3);
  }
  .backPersonCenter .roleVersion{
    font-size: 12px;
    text-align: left;
  }
  .backPersonCenter:hover >.roleVersion {
    color: #BDC6FF;
  }
  .backPersonCenter > .userHeadImg{
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 4px;

  }
  .backPersonCenter > .userHeadImg img{
    width: 100%;
    height: 100%;
  }
  @media screen and (max-width:500px ) {
  	html,body {
  		width: 100%;
  		height: 60px;
  	}
 	.navBox {
 		position: fixed;
    top: 0;
 		min-width: 100%;
 		height: 40px;
 		z-index: 1000;
 	}
 	.navBox .nav {
 		width: 100%;
 		height: auto;
 	}
 	.navBox .navLeft {
 		height: 40px;
 	}
 	.navBox .navLeft .logo {
 		height: 24px;
 		width: 24px;
 		left: 12px;
 		top: 8px;
 	}
 	.navBox .navLeft .logo img {
 		width: 24px;
 		height: 24px;
 	}
 	.navBox .navLeft .title {
 		height: 40px;
 		line-height: 40px;
 		top: 0;
 		font-size:15px;
 		margin-left: 20px;
 	}
 	.navBox .navLeft .navText {
 		display: none;
 	}
 	.navBox .navRight {
 		height:40px;
    	width:auto;
    	margin-right: 48px;
 	}
 	.navBox .backEndNavList {
 		display: none;
 	}
 	.navBox .mobile_navList {
 		position: absolute;
 		display: block;
 		width: 25px;
 		height: 25px;
 		float: right;
 		right: 14px;
 		top: 7px;
 	}
 	.navBox .mobile_navList > img {
 		width: 25px;
 		height: 21px;
 		margin-top: 2px;
 	}
 	.navBox .navBoxOther {
 		display: block;
 		position: fixed;
 		top: 40px;
 		left: 0;
 		right: 0;
 		bottom: 0;
 		width: 100%;
 		height: 100%;
 		background-color: #FFFFFF;
 		z-index: 1000;
 	}
 	.navBox .navBoxOther .navBoxOtherItem {
 		width: 100%;
 		height: 51px;
 		line-height: 51px;
 		font-size: 18px;
   }
   .backPersonCenter{
     display: none;
   }
  }
</style>

<template>
	<div class='navBox'>
    <div class='nav'>
      <div class='navLeft'>
        <div class='logo' @click="gotoPersonCenter">
          <img src="../assets/logoNew.png">
        </div>
        <!-- {{mode?"柜柜ERP":"老板良"}} -->
        <div class='title' @click="gotoPersonCenter">
          <span>门窗柜个人中心</span>
          <span style="fontSize:12px;fontWeight:500;">V1.0.0</span>
          <!-- <div class="roleVersion">
            <p>V1.0.0</p>
          </div> -->

        </div>
        <!-- <span class='navText' @click="backToMain"><i class="iconfont">&#xe743;</i>返回首页</span> -->
        <!-- <span class="navText" style="cursor: default">{{this.userData.name}}，你好</span> -->
      </div>
      <div class='navRight'>
        <div class="backPersonCenter" @mousemove="moreFunBoxShow = true" @mouseout="moreFunBoxShow = false">
          <div class="userHeadImg" @click='gotoPersonCenter'><img :src="saveMyUserInfo.logo_url ? saveMyUserInfo.logo_url:require('../assets/noHeadImg.png')" alt=""></div>
          <!-- <span>个人中心</span> -->
          <div class="roleVersion" @click='gotoPersonCenter'>
            <p>{{identityMode?(mode?saveMyUserInfo.name:saveMySupplierInfo.name):(mode?userData.name:supplierInfo.name)}}</p>
            <p>{{role}}</p>
          </div>
          <div class="moreFunBox" v-show="moreFunBoxShow">
            <div v-for=" item in identityMode?[]:moreFunList" :key="item.key" @click='changeMenu(item)'>{{item.name}}</div>
            <div @click="logout">退出登录</div>
          </div>
        </div>
        <div class='backEndNavList'>
          <div
            @click='changeMenu(item)'
            :class="['navListItem', item.key == $route.name ? 'active' : '']"
            v-for='(item,index) in countNavList'
            :key="index"
          >
            {{item.name}}
            <div v-show="item.key == $route.name && $route.name != 'QueryOrder'"></div>
            <div v-show="item.business == 'seller' && $route.params.business == 'seller' && $route.name == 'QueryOrder'"></div>
            <div v-show="item.business == 'buyer' && $route.params.business == 'buyer' && $route.name == 'QueryOrder'"></div>
          </div>
        </div>
      </div>
      <div class='mobile_navList'>
         	<img @click="showTopMenuNow" v-if="!showTopMenu" src="../assets/button_main_n.png" alt="" />
         	<img @click="showTopMenuNow" v-if="showTopMenu" src="../assets/icon_chacha_n.png" alt="" />
       </div>
    </div>
    <!--大页面跳转-->
    <!-- <div class="navBoxOther" v-if="showTopMenu">
    	<div @click='changeNow' :data-now='item' class="navBoxOtherItem" :style="now==item?'background-color:#6851FF;color:#ffffff;font-weight:bold;':''" v-for="(item,index) in list">{{item}}</div>
      <div v-for="items in modelMore" @click='changeNow' :data-now='items' class="navBoxOtherItem" :key="items">{{items}}</div>
    	<div @click="loggedout" class="navBoxOtherItem">退出登录</div>
    </div> -->
  </div>
</template>

<script>
  import login from  './Login.vue'
  import { mapMutations, mapState, mapGetters } from 'vuex'
	export default {
		components:{
      "user-login":login
		},
		props:['now','title'],
		data() {
			return {
        moreFunBoxShow:false,
        clickName: 'seller',
        moreFunList:[
          // {
          //   name: '设计订单',
          //   key: 'DesignOrder'
          // },
          {
            name: '商品管理',
            key: 'goodsManage'
          }
        ],
        list:[
          {
            name: '营销',
            key: 'marketing'
          },
          {
            name: '销售',
            key: 'QueryOrder',
            business: 'seller'
          },{
            name: '采购',
            key: 'QueryOrder',
             business: 'buyer'
          },
          {
            name: '仓库',
            key: 'storeManage'
          },
          {
            name:'车间',
            key: 'ProductOrder'
          },
          {
            name: '打包',
            key: 'SortPacking',
          },{
            name: '发货',
            key: 'deliverGoodsOrder'
          },
          // {
          //   name: '我的展厅',
          //   key: 'showRoom'
          // }
          {
            name: '客户',
            key: 'clientManage'
          },
          {
            name: '财务',
            key: 'collectionRecords'
          },
          // {
          //   name: '更多...',
          //   key: 'personalCenter'
          // },
          // {
          //   name: '会员系统',
          //   key: 'vipSystem'
          // }
          // , {
          //   name: '商品管理',
          //   key: 'goodsManage'
          // }
          ],
        showTopMenu:false,
        showTopSelect:false,
        // userData:{}
			}
		},
		computed: {
      ...mapState({
        userData: 'userInfo',
        saveMyUserInfo:'saveMyUserInfo',
        saveMySupplierInfo:'saveMySupplierInfo',
        identityMode:'identityMode',
      }),
      ...mapGetters({
        mode: 'mode',
      }),
      countNavList(){
        if(this.identityMode){
          let list = [
            {
              name: '销售',
              key: 'QueryOrder',
              business: 'seller'
            },{
              name: '采购',
              key: 'QueryOrder',
              business: 'buyer'
            },
            {
              name: '仓库',
              key: 'storeManage'
            },{
              name: '客户',
              key: 'clientManage'
            }
          ]
          return list
        }else{
          return this.list
        }
      },
      active() {
        return this.$route.name == key ? 'active' : '';
      },
      supplierInfo(){
        return this.$store.state.supplierInfo||{
           name:"",
           deposit:0
        }
      },
      role(){
        let role = ''
        console.log(this.mode)
        if(this.mode){
          // 非供应商用户角色
          let edition = this.saveMyUserInfo.edition_id
          if(edition == 1 || edition == 2){
            role = "个人"
          }else if(edition == 3 || edition == 4 || edition == 7){
            role = "门店"
          }else{
            role = "工厂"
          }
        }else{
          if(this.saveMySupplierInfo.identity == 0){
            role= '供应商'
          }else if(this.saveMySupplierInfo.identity == 1){
            role= '分仓'
          }else if(this.saveMySupplierInfo.identity == 2){
            role= '总仓'
          }
        }
        return role
      },
    },
    /* watch: {
      '$route': function () {
        this.clickName = this.$route.params.business;
      }
    }, */
		mounted() {
      console.log(this.mode)
		},
		methods: {
      ...mapMutations([
        'logout', 'changeNavNow'
      ]),
      gotoGuigui(){
        // console.log(1111)
        this.$router.replace({
          name: 'Shop'
        })
      },
      changeMenu(item) {
        // if(item.name=='会员系统'){
        //   this.$message({
        //     message:"开发中",
        //     duration:1500
        //   })
        //   return
        // }

        // this.clickName = item.name
        const routeName = item.key;
        console.log('routeName',item.key)
        // console.log('111',item,this.$route,this.clickName)
        if(item.name == '销售'){
          console.log('销售订单')
          this.clickName = 'seller'
          this.$router.push({
            name: routeName,
            params: {business: 'seller'}
          });
        }else if(item.name == '采购'){
          console.log('采购订单')
          this.clickName = 'buyer'
          this.$router.push({
            name: routeName,
            params: {business: 'buyer'}
          });
        }else{
          console.log(item)
           this.clickName = ''
           this.$router.replace({
            name: routeName
          });
        }
      },
      backToMain() {
        // 路由跳转首页
        this.$router.push({
          name: 'Shop'
        });
        // this.changeNavNow("云仓商城");
      },
      openMore(){
        this.showTopSelect = !this.showTopSelect
      },
			showTopMenuNow(){
				let that = this
	    		if(that.showTopMenu == true){
	    			that.showTopMenu = false
	    			return
	    		}
	    		that.showTopMenu = true
			},
      // logout(){
      //   this.$emit("logout")
      // },
      // logon(){
      //   this.$refs.login.logon();
      //   if(localStorage.data){
      //     this.userData = JSON.parse(localStorage.data)
      //     console.log(this.userData)
      //   }
      // },
      gotoPersonCenter(e){
        if(!localStorage.data){
          let pageTo=encodeURIComponent(location.href)
			    if(process.env.NODE_ENV=="development"){
			      location.href = 'http://localhost:8010/login.html?other=true&pageTo=' + pageTo
			    }else{
			      location.href='./login.html?pageTo='+pageTo
			    }
          return
        }
        this.$router.push({
          name: 'personalCenter'
        });
      },
      loggedout(){
      	 this.$refs.login.logout()
      }
		}
	}
</script>
